module.exports = "../images/cabin-6-person-1.jpg?v=eeb6dac";